/**
 * HubDifficultyBadges — 학습 화면 「강의」 보기의 행 끝 난이도 원형 배지 다섯(설계 FE-20260914 §6).
 *
 * 색·모양은 문제 v2 표의 원형 난이도 배지와 같다 — 색은 공용 값(problemApi.difficultyBadgeClass: 1 노랑 … 5 빨강),
 * 모양은 표의 원(size-6). 같은 난이도가 화면마다 다른 색으로 보이지 않게 한다.
 * 다른 것은 글자뿐이다 — 원 안에 난이도 번호 대신 정답률(0~100)을 적어, 세 자리가 들어가게 10px 로 둔다.
 * 상태: 정상 · 흐림(풀이 1~2회) · 점선 「–」(풀이 없음) · 빈 회색 원(행 조건의 난이도 밖) · 불러오는 중(회색 원이 깜빡임).
 * 수치는 원 위에 커서를 올리면 뜬다(title) — 계산은 syllabusProgress.badgeCells.
 */
import { difficultyBadgeClass } from '../ProblemHubV2/problemApi';
import { DIFFICULTIES } from './syllabusProgress';

const BASE = 'inline-flex size-6 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold tabular-nums';

function HubDifficultyBadges({ cells = [], loading = false }) {
  if (loading) {
    return (
      <span data-badges="loading" className="inline-flex gap-1" role="status" aria-label="난이도 배지를 불러오는 중">
        {DIFFICULTIES.map((d) => <span key={d} aria-hidden="true" className={`${BASE} animate-pulse bg-gray-100`} />)}
      </span>
    );
  }
  return (
    <span data-badges="" className="inline-flex gap-1" role="group" aria-label="난이도별 정답률">
      {cells.map((c) => {
        if (c.kind === 'out') {
          return <span key={c.d} data-kind="out" role="img" aria-label={c.title} title={c.title} className={`${BASE} border border-gray-200 bg-gray-50`} />;
        }
        if (c.kind === 'none') {
          return <span key={c.d} data-kind="none" role="img" aria-label={c.title} title={c.title} className={`${BASE} border border-dashed border-gray-300 font-normal text-gray-400`}>–</span>;
        }
        return (
          <span
            key={c.d}
            data-kind={c.kind}
            role="img"
            aria-label={c.title}
            title={c.title}
            className={`${BASE} ${difficultyBadgeClass(c.d)}${c.kind === 'thin' ? ' opacity-50' : ''}`}
          >
            {c.rate}
          </span>
        );
      })}
    </span>
  );
}

export default HubDifficultyBadges;
